module.exports = __webpack_public_path__ + "static/media/asignatura6.1df4184f.png";